import AuthProtected from '@/components/app/utils/auth-protected/AuthProtected';
import { useCurrentUser } from '@/hooks/data/user';
import { Flex, Typography } from 'antd';
import AccountLayout from '../../components/app/layouts/account-layout/AccountLayout';
import AppPlanCard from '../../components/app/subscriptions/app-plan/AppPlanCard';

const { Title } = Typography;

export default function SubscriptionPage() {
   const { user, error, isLoading } = useCurrentUser();

   const ACTIVE_STATUSES = ['active', 'trialing', 'past_due', 'paused'];
   const userPremiumSubsciption = user?.subscriptions.filter((subscription) => {
      if (!ACTIVE_STATUSES.includes(subscription.status)) return false;
      // Paid/trial subs from either provider count as premium.
      return Boolean(subscription.paddleSubscriptionId || subscription.stripeSubscriptionId);
   })[0];
   const userFreeSubsciption = user?.subscriptions.filter(
      (subscription) => !subscription.paddleSubscriptionId && !subscription.stripeSubscriptionId
   )[0];

   if (isLoading) {
      return <div>Loading...</div>;
   }
   if (error) {
      return <div>Error: {error}</div>;
   }

   return (
      <Flex vertical gap={32} style={{ width: '100%' }}>
         <Title level={4}>Subscriptions</Title>

         {userPremiumSubsciption && (
            <div key={userPremiumSubsciption._id}>
               <AppPlanCard user={user} subscriptions={userPremiumSubsciption} />
            </div>
         )}
         {!userPremiumSubsciption && (
            <div key={userFreeSubsciption._id}>
               <AppPlanCard user={user} subscriptions={userFreeSubsciption} />
            </div>
         )}
      </Flex>
   );
}

SubscriptionPage.getLayout = (page) => (
   <AuthProtected>
      <AccountLayout user={page.user} page={'subscription'}>
         {page}
      </AccountLayout>
   </AuthProtected>
);
